import { useCallback } from 'react';

import { StepProps, useFlowState } from '@betterment/js-runtime';
import { SuccessFullScreen } from '@betterment/samba-react';

import { locationAssign } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';
import { PortfolioFlowState } from '../data';

const PortfolioSuccessStep: React.FC<React.PropsWithChildren<StepProps>> = () => {
  const {
    flowState: {
      values: { accountId, shouldReturnToAppSummary },
    },
  } = useFlowState<PortfolioFlowState>();

  const complete = useCallback(() => {
    if (shouldReturnToAppSummary) {
      locationAssign(urlBuilder.appHome.absolute());
    } else {
      locationAssign(urlBuilder.appAccount.absolute({ accountId }));
    }
  }, [accountId, shouldReturnToAppSummary]);

  return <SuccessFullScreen message="Allocation settings updated successfully!" onCompletion={complete} />;
};

export default PortfolioSuccessStep;
